import Model, { attr } from '@ember-data/model';
import { cached, tracked } from '@glimmer/tracking';

export default class CampaignModel extends Model {
  @attr('string') name!: string;
  @attr('string') parentCampaignId?: string;
  @attr('boolean') restricted!: boolean;

  // these properties will be populated in the campaignService
  @tracked parentCampaign?: CampaignModel;
  @tracked childrenCampaigns: CampaignModel[] = [];
  @tracked ancestorCampaigns: CampaignModel[] = []; // starting with parent

  @cached
  get ancestorCount() {
    let count = 0;
    if (this.parentCampaign) {
      count = this.parentCampaign.ancestorCount + 1;
    }
    return count;
  }

  @cached
  get label(): string {
    return this.parentCampaign
      ? `${this.parentCampaign.label}: ${this.name}`
      : this.name;
  }

  // returns array of the current campaign id along with all descendant campaign ids
  @cached
  get idAndDescendantIds(): string[] {
    let ids = [this.id];
    for (let child of this.childrenCampaigns) {
      ids = [...ids, ...child.idAndDescendantIds];
    }
    return ids;
  }

  isDescendantOf(campaign: CampaignModel): boolean {
    return this.ancestorCampaigns.some((c) => c.id === campaign.id);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    campaign: CampaignModel;
  }
}
